<template>
  <div class="reports-view">
    <div class="bar_title mb-8 shadow-lg">
      <p class="title_bar_text">Reporte de envío de correos</p>
    </div>
    <section class="report-panel">
      <div class="metrics-grid">
        <article v-for="metric in metrics" :key="metric.label" class="metric-item relative">
          <p class="metric-label">{{ metric.label }}</p>
          <div @click="download_report(metric.label)" v-if="['Correos invalidos', 'Sin correo'].includes(metric.label)"
            type="button" class="metric-action inline-flex cursor-pointer items-center "
            :title="'Descargar reporte de ' + metric.label + ' en Excel'">
            <i class="material-icons">file_download</i>
          </div>
          <p class="metric-value">
            {{ metric.value }}
          </p>
          <p v-if="metric.detail" class="metric-detail">{{ metric.detail }}</p>
        </article>
      </div>

      <div class="capacity-block">
        <p class="section-title">Capacidad mensual de correos</p>

        <div class="progress-track" aria-label="Capacidad mensual de correos">
          <div class="progress-fill" :style="{ width: emailCapacity.sentPercent + '%' }"></div>
        </div>

        <div class="capacity-labels">
          <div>
            <strong>{{ emailCapacity.total }}</strong>
            <span>total</span>
          </div>
          <div class="capacity-sent">
            <strong>{{ emailCapacity.sent }}</strong>
            <span>enviados ({{ emailCapacity.sentPercent }}%)</span>
          </div>
          <div class="capacity-available">
            <strong>{{ emailCapacity.available }}</strong>
            <span>disponibles ({{ emailCapacity.availablePercent }}%)</span>
          </div>
        </div>
      </div>

      <div class="batch-summary">
        <p class="section-title">Resumen del lote</p>

        <data-table class="mt-2" :columns="tableColumns" :rows="data" :per-page="10" row-key="id"
          search-placeholder="Buscar en el resumen..." />
      </div>
    </section>
  </div>
</template>

<script>
import axios from '@/axios';
import DataTable from '@/components/DataTable.vue';
import * as XLSX from 'xlsx';

export default {
  components: {
    DataTable,
  },
  data() {
    return {
      metrics: [
        {
          label: "Cuentas seleccionadas",
          value: "0",
        },
        {
          label: "Emails validos",
          value: "0",
          detail: "(0%)",
        },
        {
          label: "Correos invalidos",
          value: "0",
          detail: "(0%)",
        },
        {
          label: "Sin correo",
          value: "0",
          detail: "(0%)",
        },
        {
          label: "Saldo actual",
          value: "B/. 0",
        },
        {
          label: "Cupo disponible del mes",
          value: "0",
          detail: "(0%)",
        },
      ],
      emailCapacity: {
        total: "100,000",
        sent: "0",
        sentPercent: 0,
        available: "100,000",
        availablePercent: 100,
      },
      tableColumns: [
        {
          key: "Segmentacion",
          label: "Segmentacion",
          align: "center",
        },
        {
          key: "Tipo_cuenta",
          label: "Tipo cuenta",
          align: "center",
        },
        {
          key: "Antiguedad",
          label: "Antiguedad",
          align: "center",
        },
        {
          key: "Cantidad_cuentas",
          label: "Cantidad cuentas",
          align: "center",
          minWidth: 180,
        },
        {
          key: "Saldo_actual",
          label: "Saldo actual",
          align: "center",
          formatter: value => `B/. ${parseFloat(value).toFixed(2)}`,
          minWidth: 170,
        },
        {
          key: "Correos_validos",
          label: "Correos validos",
          align: "center",
          minWidth: 170,
        },
      ],
      batchRows: [
        {
          id: 1,
          segmentacion: "Persona Natural",
          tipoCuenta: "Prepago",
          antiguedad: "Mas de 720 dias",
          cantidadCuentas: "18,189",
          saldoActual: "B/. 714,679.64",
          correosValidos: "15,032",
        },
        {
          id: 2,
          segmentacion: "Persona Natural",
          tipoCuenta: "Postpago/Gobierno",
          antiguedad: "Mas de 720 dias",
          cantidadCuentas: "14,360",
          saldoActual: "B/. 541,230.59",
          correosValidos: "11,427",
        },
        {
          id: 3,
          segmentacion: "Persona Juridica",
          tipoCuenta: "Prepago",
          antiguedad: "361 a 720 dias",
          cantidadCuentas: "8,532",
          saldoActual: "B/. 235,781.33",
          correosValidos: "6,958",
        },
        {
          id: 4,
          segmentacion: "Gobierno",
          tipoCuenta: "Postpago/Gobierno",
          antiguedad: "181 a 360 dias",
          cantidadCuentas: "4,231",
          saldoActual: "B/. 148,633.46",
          correosValidos: "3,216",
        },
        {
          id: 5,
          segmentacion: "Persona Natural",
          tipoCuenta: "Prepago",
          antiguedad: "181 a 360 dias",
          cantidadCuentas: "2,390",
          saldoActual: "B/. 112,565.10",
          correosValidos: "1,819",
        },
      ],
      data: [],
      sendgridStats: {
        sent: 0,
        delivered: 0,
        failed: 0,
        invalid: 0,
        totalQuota: 100000,
      },
    };
  },
  methods: {
    getReportData() {
      this.$vs.loading();
      let me = this;
      return axios
        .get(`auth/get_reporte_correos`, this.config)
        .then(function (response) {
          me.metrics[0].value = response.data.reduce((acc, item) => acc + +item.Cantidad_cuentas, 0);
          me.metrics[1].value = response.data.reduce((acc, item) => acc + +item.Correos_validos, 0);
          me.metrics[1].detail = "(" + ((me.metrics[1].value / me.metrics[0].value) * 100).toFixed(2) + "%)";
          me.metrics[2].value = response.data.reduce((acc, item) => acc + +item.Correos_invalidos, 0);
          me.metrics[2].detail = "(" + ((me.metrics[2].value / me.metrics[0].value) * 100).toFixed(2) + "%)";
          me.metrics[3].value = response.data.reduce((acc, item) => acc + +item.Sin_correo, 0);
          me.metrics[3].detail = "(" + ((me.metrics[3].value / me.metrics[0].value) * 100).toFixed(2) + "%)";
          me.metrics[4].value = "B/. " + response.data.reduce((acc, item) => acc + +item.Saldo_actual, 0).toFixed(2);
          me.data = response.data;
          me.$vs.loading.close();
        })
        .catch(function (error) {
          me.$vs.loading.close();
        });
    },
    getSendgridStats() {
      this.$vs.loading();
      let me = this;
      return axios
        .get(`auth/getSendgridStats`, this.config)
        .then(function (response) {
          me.sendgridStats.sent = response.data.sent;
          me.sendgridStats.delivered = response.data.delivered;
          me.sendgridStats.failed = response.data.failed;
          me.sendgridStats.invalid = response.data.invalid;
          me.metrics[5].value = me.sendgridStats.totalQuota - me.sendgridStats.sent;
          me.metrics[5].detail = "(" + ((me.metrics[5].value / me.sendgridStats.totalQuota) * 100).toFixed(2) + "%)";
          me.emailCapacity.sent = me.sendgridStats.sent.toLocaleString();
          me.emailCapacity.sentPercent = ((me.sendgridStats.sent / me.sendgridStats.totalQuota) * 100).toFixed(2);
          me.emailCapacity.available = (me.sendgridStats.totalQuota - me.sendgridStats.sent).toLocaleString();
          me.emailCapacity.availablePercent = ((me.metrics[5].value / me.sendgridStats.totalQuota) * 100).toFixed(2);
          me.$vs.loading.close();
        })
        .catch(function (error) {
          me.$vs.loading.close();
        });
    },
    download_report(label) {
      let me = this;
      let endpoint = '';
      if (label === 'Correos invalidos') {
        endpoint = 'auth/download_invalid_emails';
      } else if (label === 'Sin correo') {
        endpoint = 'auth/download_empty_emails';
      } else {
        return;
      }
      this.$vs.loading();
      axios
        .get(endpoint, { responseType: 'blob' })
        .then(function (response) {
          try {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${label.replace(/\s+/g, '_').toLowerCase()}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); 
          } catch (error) {
            console.log(error)
          } finally {
            me.$vs.loading.close();
          }
        })
        .catch(function (error) {
          console.log(error)
          me.$vs.loading.close();
        });
    },
  },
  async mounted() {
    await this.getReportData();
    await this.getSendgridStats();
  }
};
</script>

<style lang="scss" scoped>
.reports-view {
  color: #22292f;
}

.bar_title {
  background-color: #21409a;
  border-radius: 10px;
  padding: 10px 10px 10px 20px;
  color: white;
  font-size: 2.3vh;
  font-weight: 300;
}

.title_bar_text {
  margin: 0;
}

.report-panel {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #dfe4ee;
  box-shadow: 0 8px 18px rgba(31, 47, 88, 0.08);
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-bottom: 1px solid #dfe4ee;
}

.metric-item {
  min-height: 80px;
  padding: 12px 24px;
  border-right: 1px solid #dfe4ee;
}

.metric-item:last-child {
  border-right: 0;
}

.metric-label,
.section-title {
  margin: 0;
  color: #21409a;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.2;
}

.metric-value {
  margin: 6px 0 0;
  color: #22292f;
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 1.1;
  white-space: nowrap;
}


.metric-action {
  border: 1px solid #dfe4ee;
  border-radius: 4px;
  padding: 1px 2px;
  position: absolute;
  top: 8px;
  right: 8px;
}

.metric-detail {
  margin: 8px 0 0;
  color: #21409a;
  font-size: 0.875rem;
  font-weight: 500;
}

.capacity-block,
.batch-summary {
  padding: 22px 18px;
  border-bottom: 1px solid #dfe4ee;
}

.batch-summary {
  border-bottom: 0;
  padding-top: 18px;
}

.progress-track {
  width: 100%;
  height: 16px;
  margin-top: 14px;
  overflow: hidden;
  background: #d5dbe5;
  border-radius: 4px;
}

.progress-fill {
  height: 100%;
  background: #0056e6;
  border-radius: 4px;
}

.capacity-labels {
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 14px;
  color: #22292f;
}

.capacity-labels div {
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.2;
}

.capacity-labels strong {
  color: #21409a;
  font-size: 1rem;
  font-weight: 500;
}

.capacity-sent {
  text-align: center;
}

.capacity-available {
  text-align: right;
}

@media (max-width: 1199px) {
  .metrics-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .metric-item:nth-child(3n) {
    border-right: 0;
  }

  .metric-item:nth-child(-n + 3) {
    border-bottom: 1px solid #dfe4ee;
  }
}

@media (max-width: 767px) {
  .metrics-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .metric-item,
  .metric-item:nth-child(3n) {
    min-height: 112px;
    padding: 18px;
    border-right: 1px solid #dfe4ee;
  }

  .metric-item:nth-child(2n) {
    border-right: 0;
  }

  .metric-item:nth-child(-n + 4) {
    border-bottom: 1px solid #dfe4ee;
  }

  .metric-value {
    font-size: 1.25rem;
  }

  .capacity-labels {
    grid-template-columns: 1fr;
  }

  .capacity-sent,
  .capacity-available {
    text-align: left;
  }
}

@media (max-width: 479px) {
  .metrics-grid {
    grid-template-columns: 1fr;
  }

  .metric-item,
  .metric-item:nth-child(2n),
  .metric-item:nth-child(3n) {
    border-right: 0;
    border-bottom: 1px solid #dfe4ee;
  }

  .metric-item:last-child {
    border-bottom: 0;
  }
}
</style>
